import * as React from 'react';

import { SettingsProviderProps } from './types';
import { SettingsContext } from './utils';

const { useMemo } = React;

export const SettingsProvider = ({
  children,
  onSaveProfile,
  onChangePassword,
  onChangeEmail,
  onDeleteAccount,
  onUpdatePreferences,
  onUpdateAvailability,
  onInviteUsers,
  onRemoveUser,
  onUpdateMemberAccess,
  onUpdateOrganisationName,
  onDeleteOrganisation,
  onUpdateOrganisationImage,
  onUpdateOrganisationLogo,
  onConvertUser,
}: SettingsProviderProps): JSX.Element => {
  const ctxValue = useMemo(() => {
    return {
      callbacks: {
        onSaveProfile,
        onChangePassword,
        onChangeEmail,
        onDeleteAccount,
        onUpdatePreferences,
        onUpdateAvailability,
        onInviteUsers,
        onRemoveUser,
        onUpdateMemberAccess,
        onUpdateOrganisationName,
        onDeleteOrganisation,
        onUpdateOrganisationImage,
        onConvertUser,
        onUpdateOrganisationLogo,
      },
    };
  }, [
    onSaveProfile,
    onChangePassword,
    onUpdatePreferences,
    onUpdateAvailability,
    onDeleteAccount,
    onInviteUsers,
    onRemoveUser,
    onUpdateMemberAccess,
    onUpdateOrganisationName,
    onDeleteOrganisation,
    onUpdateOrganisationImage,
    onUpdateOrganisationLogo,
    onConvertUser,
  ]);

  return <SettingsContext.Provider value={ctxValue}>{children}</SettingsContext.Provider>;
};
